import styled from "styled-components";
import { darken } from "polished";
import { Variables } from "../../styles/Variables";

export const Container = styled.div``;

export const Input = styled.input`
  overflow: hidden;
  width: 0;
  height: 0;
`;
export const Label = styled.label`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  outline: none;
  margin-bottom: 1rem;
  padding: 1rem 50px;
  border: none;
  border-radius: 10px;
  background-color: ${Variables.colorGrayIcons};
  cursor: pointer;
  font-size: inherit;
  font-weight: 500;
  color: white;

  & :hover {
    background-color: ${darken(0.1, Variables.colorGrayIcons)};
  }
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 544px;
  border-radius: 10px;
  object-fit: cover;
`;
